import React from "react";
import { Navigate, useParams } from "react-router-dom";
import { useUser } from "../../contexts/UserContext";
import { canManageNetwork } from "../../utils/authorization";

const NetworkAdminRouteGuard = ({ children }) => {
  const { networkId } = useParams();
  const { user, isLoading } = useUser();

  if (isLoading) return null;
  if (canManageNetwork(user, networkId)) return children;

  return <Navigate to={`/app/network/${networkId}`} replace />;
};

export default NetworkAdminRouteGuard;
